import { useMutation, useQueryClient } from "@tanstack/react-query";
import galleriesAPI from "../../api/galleries/api";

export function useCreateGallery() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: galleriesAPI.createGallery,
    onSuccess: () => {
      // Invalidate and refetch galleries list
      queryClient.invalidateQueries({ queryKey: ["galleries"] });
    },
    onError: (error) => {
      console.error("Create gallery failed:", error);
    },
  });
}
